<template>
  <template v-if="showView">
    <nav class="navbar position-fixed fixed-top navbar-dark bg-primary mb-3 bg-cover no-print" :style="{
      backgroundColor: (backgroundHeaderColor ? backgroundHeaderColor : (devEnvironmentName ? '#5ccbff' : '#496c70')) + ' !important',
    }">
      <div class="container-fluid">
        <div class="applications-wrapper">
          <ApplicationMenu v-if="!$root?.features?.loginPortal?.enabled" />
          <a class="navbar-brand" href="/">
            <img :src="defaultLogoLightUrl" :alt="defaultCompanyAlias" height="38" data-logo="light">
            <span class="brand-separator"></span> <span class="text-uppercase brand-application">
              {{ appName }}
              {{ devEnvironmentName }}
            </span>
          </a>
        </div>
        <div class="btn-group">
          <slot name="buttons"></slot>
          <button class="btn btn-outline-light d-lg-none" type="button" data-bs-toggle="offcanvas"
            data-bs-target="#aside-menu" aria-controls="aside-menu">
            <i class="custom-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list"
                viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
              </svg>
            </i>
          </button>
        </div>
      </div>
    </nav>

    <template v-if="showMenu">
      <SideMenu>
        <ul class="nav nav-pills flex-column mb-auto">
          <li class="nav-item" v-if="listOfAccessiblePages.includes('DashboardIndex')">
            <router-link :to="{ name: 'DashboardIndex' }" class="nav-link link-dark"
              v-if="can('DASHBOARD_ACCESS') && this.$root.features?.dashboard?.enabled">
              <DashboardIcon />
              <div class="slim-hide">{{ i18n('Dashboard') }}</div>
            </router-link>
          </li>
          <li class="nav-item" v-if="listOfAccessiblePages.includes('UserIndex')">
            <router-link :to="{ name: 'UserIndex' }" class="nav-link link-dark"
              :class="{ 'active': $route.name === 'UserDetail' }">
              <UserIcon />
              <div class="slim-hide">{{ i18n('Users') }}</div>
            </router-link>
          </li>
          <li class="nav-item" v-if="listOfAccessiblePages.includes('LocalUserIndex')">
            <router-link :to="{ name: 'LocalUserIndex' }" class="nav-link link-dark"
              :class="{ 'active': $route.name === 'LocalUserDetail' }">
              <LockFillIcon />
              <div class="slim-hide">{{ i18n('Local Users') }}</div>
            </router-link>
          </li>
          <li class="nav-item" v-if="listOfAccessiblePages.includes('ProfileUserIndex')">
            <router-link :to="{ name: 'ProfileUserIndex' }" class="nav-link link-dark">
              <KeyIcon />
              <div class="slim-hide">{{ i18n('Profiles') }}</div>
            </router-link>
          </li>
          <li class="nav-item" v-if="listOfAccessiblePages.includes('CompanyIndex')">
            <router-link :to="{ name: 'CompanyIndex' }" class="nav-link link-dark"
              :class="{ 'active': $route.name === 'CompanyDetail' }">
              <BuildingIcon />
              <div class="slim-hide">{{ i18n('Companies') }}</div>
            </router-link>
          </li>
          <li class="nav-item" v-if="listOfAccessiblePages.includes('OfficeIndex')">
            <router-link :to="{ name: 'OfficeIndex' }" class="nav-link link-dark"
              :class="{ 'active': $route.name === 'OfficeIndex' }">
              <MarkerIcon />
              <div class="slim-hide">{{ i18n('Offices') }}</div>
            </router-link>
          </li>
          <li class="nav-item" v-if="listOfAccessiblePages.includes('DepartmentIndex')">
            <router-link :to="{ name: 'DepartmentIndex' }" class="nav-link link-dark"
              :class="{ 'active': $route.name === 'DepartmentIndex' }">
              <MarkerIcon />
              <div class="slim-hide">{{ i18n('Departments') }}</div>
            </router-link>
          </li>
          <li class="nav-item" v-if="listOfAccessiblePages.includes('RoleIndex')">
            <router-link :to="{ name: 'RoleIndex' }" class="nav-link link-dark"
              :class="{ 'active': $route.name === 'RoleIndex' }">
              <ComputerIcon />
              <div class="slim-hide">{{ i18n('Roles') }}</div>
            </router-link>
          </li>
          <li class="nav-item" v-if="listOfAccessiblePages.includes('ProviderIndex')">
            <router-link :to="{ name: 'ProviderIndex' }" class="nav-link link-dark"
              :class="{ 'active': $route.name === 'ProviderDetail' }">
              <FolderIcon />
              <div class="slim-hide">{{ i18n('Providers') }}</div>
            </router-link>
          </li>
          <li class="nav-item" v-if="listOfAccessiblePages.includes('TriggerIndex')">
            <router-link :to="{ name: 'TriggerIndex' }" class="nav-link link-dark"
              :class="{ 'active': $route.name === 'TriggerIndex' }">
              <LockFillIcon />
              <div class="slim-hide">{{ i18n('Triggers') }}</div>
            </router-link>
          </li>
          <li class="nav-item" v-if="listOfAccessiblePages.includes('ApplicationIndex')">
            <router-link :to="{ name: 'ApplicationIndex' }" class="nav-link link-dark"
              :class="{ 'active': $route.name === 'ApplicationDetail' && ($route.params.id != 1) }">
              <ApplicationIcon />
              <div class="slim-hide">{{ i18n('Applications') }}</div>
            </router-link>
          </li>
          <li class="nav-item" v-if="listOfAccessiblePages.includes('AuditIndex')">
            <router-link :to="{ name: 'ApplicationDetail', params: { id: 1 } }" class="nav-link link-dark">
              <PantheonIcon />
              <div class="slim-hide">{{ appName }}</div>
            </router-link>
          </li>
          <li class="nav-item" v-if="listOfAccessiblePages.includes('AuditChangeIndex')">
            <router-link :to="{ name: 'AuditChangeIndex' }" class="nav-link link-dark"
              :class="{ 'active': $route.name === 'AuditChangeIndex' }">
              <LockFillIcon />
              <div class="slim-hide">{{ i18n('Audit') }}</div>
            </router-link>
          </li>
          <li class="nav-item" v-if="listOfAccessiblePages.includes('AuditLoginIndex')">
            <router-link :to="{ name: 'AuditLoginIndex' }" class="nav-link link-dark"
              :class="{ 'active': $route.name === 'AuditLoginIndex' }">
              <LockFillIcon />
              <div class="slim-hide">{{ i18n('Login audit') }}</div>
            </router-link>
          </li>
          <li class="nav-item" v-if="listOfAccessiblePages.includes('ExpiredSoonUserIndex')">
            <router-link :to="{ name: 'ExpiredSoonUserIndex' }" class="nav-link link-dark"
              :class="{ 'active': $route.name === 'ExpiredSoonUserIndex' }">
              <HourglassIcon />
              <div class="slim-hide">{{ i18n('Soon to expire') }}</div>
            </router-link>
          </li>
        </ul>
        <template #userMenu>
          <ul class="dropdown-menu text-small shadow">
            <template v-for="lang in ['es', 'en']" :key="lang">
              <li v-if="$root.getCurrentLang() !== lang">
                <a class="dropdown-item" href="javascript:void(0)" @click="$root.switchLang(lang)">
                  {{ i18n('View in {lang}').replace('{lang}', lang.toUpperCase()) }}</a>
              </li>
            </template>
            <li v-if="this.$root?.features?.users?.otp?.two_factor_authentication?.enabled">
              <a v-if="this.$root.loggedUser.is_2fa_enabled" class="dropdown-item" href="javascript:void(0)"
                @click="$root.requestConfirmation($root.i18n('Are you sure you want to reset the Two-Factor Authentication?'), () => { this.$refs['LoginAd2faEnableModal'].show(); })">
                {{ i18n('Reset Two-Factor Auth') }}
              </a>
              <a v-else class="dropdown-item" href="javascript:void(0)" @click="activate2FA">
                {{ i18n('Activate Two-Factor Auth') }}
              </a>
            </li>
            <li class="dropdown-divider"></li>
            <li>
              <a class="dropdown-item" href="javascript:void(0)" @click="logout">{{ i18n('Logout') }}</a>
            </li>
          </ul>
        </template>
      </SideMenu>
    </template>

    <main class="container-fluid mt-5 pt-4" :class="{ 'no-aside-menu': !showMenu }">
      <slot></slot>
    </main>
    <BackToTop />
  </template>
  <LoginAd2faEnableModal ref="LoginAd2faEnableModal" @reload="reload()"
    :user="this.$root.loggedUser" />
</template>

<script>
import $env from "@/tools/environment.js";
const appName = $env('VITE_APP_NAME');
const defaultLogoLightUrl = $env('VITE_DEFAULT_LOGO_LIGHT_URL');
const defaultCompanyAlias = $env('VITE_DEFAULT_COMPANY_ALIAS');
const defaultIcoUrl = $env('VITE_DEFAULT_ICO_URL');
const ignoreUserCompany = $env('VITE_IGNORE_USER_COMPANY');
const redirectUri = $env("VITE_REDIRECT_LOGOUT_URL");
import { accessiblePages } from "@/routeAcl.js";
import api from "@/api.js";
import ApplicationMenu from "@/components/common/layout/ApplicationMenu.vue";
import SideMenu from "@/components/common/layout/SideMenu.vue";
import DashboardIcon from "@/assets/svg/dashboard.vue";
import ApplicationIcon from "@/assets/svg/application.vue";
import UserIcon from "@/assets/svg/user.vue";
import HourglassIcon from "@/assets/svg/hourglass.vue";
import ListIcon from "@/assets/svg/list.vue";
import LockFillIcon from "@/assets/svg/lock-fill.vue";
import FolderIcon from "@/assets/svg/folder.vue";
import BuildingIcon from "@/assets/svg/building.vue";
import BackToTop from '@/components/common/layout/BackToTop.vue';
import PantheonIcon from '@/assets/svg/pantheon.vue';
import MarkerIcon from '@/assets/svg/marker.vue';
import KeyIcon from '@/assets/svg/key.vue';
import ComputerIcon from '@/assets/svg/computer.vue';
import LoginAd2faEnableModal from '@/components/loginAd/LoginAd2faEnableModal.vue';

export default {
  components: {
    ApplicationMenu,
    SideMenu,
    KeyIcon,
    DashboardIcon,
    ApplicationIcon,
    UserIcon,
    ListIcon,
    LockFillIcon,
    FolderIcon,
    BuildingIcon,
    BackToTop,
    PantheonIcon,
    ComputerIcon,
    MarkerIcon,
    HourglassIcon,
    LoginAd2faEnableModal,
  },
  props: {
    allowAnonymous: {
      type: Boolean,
      default: false,
    },
    showMenu: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      devEnvironmentName: false,
      appName,
      defaultLogoLightUrl,
      defaultCompanyAlias,
      backgroundHeaderColor: import.meta.env.VITE_HEADER_COLOR ? import.meta.env.VITE_HEADER_COLOR : '',
      show2faModal: false,
    };
  },
  computed: {
    showView() {
      return !!this.allowAnonymous || !!(this.$root.loggedUser && this.$root.loggedUser.id);
    },
    listOfAccessiblePages() {
      return accessiblePages(this.$root.loggedUser, this.$root.features);
    },
  },
  methods: {
    logout() {
      let redirect = {};
      redirect.name = 'Logout';

      if (redirectUri) {
        redirect.query = { redirect_uri: redirectUri };
      }

      this.$router.push(redirect);
    },
    activate2FA() {
      this.$refs['LoginAd2faEnableModal'].show();
    },
    reload() {
      window.location.reload();
    }
  },
  mounted() {
    api.auth().then((user) => {
      this.$root.loggedUser = user;
      let company = null;

      if (user?.company
        && !ignoreUserCompany) {
        company = user.company;
      }

      if (company) {
        this.$root.setCompanyName(user.company.alias);

        [...document.querySelectorAll('[data-logo="light"]')].forEach(e => {
          e.alt = user.company.alias;
          e.src = user.company.logo.light_png_url;
        });
        [...document.querySelectorAll('[data-logo="default"]')].forEach(e => {
          e.alt = user.company.alias;
          e.src = user.company.logo.png_url;
        });
      }

      let icoUrl = company?.logo?.icon_url || defaultIcoUrl;

      if (icoUrl) {
        let link = document.querySelector('link[rel~="icon"]');

        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.head.appendChild(link);
        }

        link.href = icoUrl;
      }
    });
  },
  created() {
    this.devEnvironmentName = api.devEnvironmentName();

    if (!this.allowAnonymous &&
      !api.hasAuthToken()) {
      api.login(
        this.$route.query, {
        name: this.$route.name,
        params: this.$route.params
      }).then((route) => {
        this.$root.loadFeatures();
        this.$router.push(route);
      });
    } else if (api.hasAuthToken()) {
      api.auth().then((user) => {
        this.$root.loggedUser = user;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.navbar-brand {
  display: flex;
  flex-direction: column;
}

@media screen and (max-width:511px) {
  .navbar-brand img {
    height: 24px;
    object-fit: contain;
    object-position: left;
  }

  .applications-wrapper {
    .applications-trigger {
      margin-left: 0;
      opacity: 1;
      color: var(--bs-white);
      cursor: pointer;

      .custom-icon__big {
        color: currentColor;
      }
    }
  }
}

@media screen and (min-width:512px) {
  .navbar-brand {
    flex-direction: row;
    align-items: center;
  }

  .brand-separator {
    display: inline-block;
    margin-right: 11px;
    margin-left: 9px;
    background-color: var(--bs-gray-500);
    width: 1px;
    height: 30px;
  }

  .brand-application {
    font-size: 16px;
    font-weight: 400;
    letter-spacing: 0.035rem;
    margin-top: 3px;
  }
}

.brand-application {
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.035rem;
  margin-top: 3px;
}

.applications-wrapper {
  display: flex;
  align-items: center;
}
</style>